import {Link} from "react-router-dom";
import {BoxArrowUpRight} from "react-bootstrap-icons";
import {adminRoutes} from "../../../utils/routes";
import {User} from "fearless-common";
import {UserNameSpan} from "fearless-common-ui";

/**
 * Renders an admin-specific user name span with additional user information and a link to the admin user page.
 *
 * @param {Object} props - The properties object.
 * @param {User} props.user - The user object containing user details.
 * @param {'span' | 'div'} [props.as='span'] - The HTML element type to render as (either 'span' or 'div').
 * @return {JSX.Element} A JSX element containing the user name, user ID, and a link to the admin user component.
 */
export default function AdminUserNameSpan({ user, as: As = 'span' }: {
  user: User
  as?: 'span' | 'div'
}) {
  return (
    <As>
      <UserNameSpan user={user} />
      &nbsp;
      <small className="text-muted">{user.id}</small>
      <Link to={adminRoutes.user(user.id)}>
        <BoxArrowUpRight />
      </Link>
    </As>
  );
}
